// extracted by mini-css-extract-plugin
export default {"message":"VerifyPhoneNumber_message__2O9y9","groupTitle":"VerifyPhoneNumber_groupTitle__LDcnv"};